import { Typography } from 'components/core-v2/atoms'

export const Success = () => (
  <>
    <Typography className="mb-3" variant="h5">
      Success
    </Typography>
    <Typography variant="b2">Your password has been changed</Typography>
  </>
)
